import { ref } from 'vue';

interface LightboxState {
  open: boolean;
  items: any[];
  currentIndex: number;
}

const lightboxState = ref<LightboxState>({
  open: false,
  items: [],
  currentIndex: 0,
});

export const useMediaLightbox = () => {
  const openLightbox = (item: any, allItems?: any[]) => {
    const items = allItems || [item];

    // Find index of clicked item in the array
    let index = 0;
    if (allItems) {
      index = allItems.findIndex((i) => {
        // Match by videoId
        if (i.video?.video?.videoId && item.video?.video?.videoId) {
          return i.video.video.videoId === item.video.video.videoId;
        }
        // Match by videoSrc
        if (i.videoSrc && item.videoSrc) {
          return i.videoSrc === item.videoSrc;
        }
        // Match by streamyardId
        if (i.streamyardId && item.streamyardId) {
          return i.streamyardId === item.streamyardId;
        }
        // Match by title as fallback
        return i.title === item.title;
      });
    }

    lightboxState.value = {
      open: true,
      items,
      currentIndex: Math.max(0, index),
    };
  };

  const closeLightbox = () => {
    lightboxState.value.open = false;
  };

  const updateIndex = (index: number) => {
    lightboxState.value.currentIndex = index;
  };

  return {
    lightboxState,
    openLightbox,
    closeLightbox,
    updateIndex,
  };
};
